<template>
    <div>
        <IndexNavbar />
        <main>
            <div class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
                <div class="absolute top-0 w-full h-full bg-center bg-cover"
          :style="`background-image: url('${backgroundImage}');`">
                    <span id="blackOverlay" class="w-full h-full absolute opacity-75 bg-black"></span>
                </div>
                <div class="container relative mx-auto">
                    <div class="items-center flex flex-wrap">
                        <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                            <div class="pr-12">
                                <h1 class="text-white font-semibold text-5xl">
                                    Services
                                </h1>
                                <p class="mt-4 text-lg text-blueGray-200">
                                    At AmeiseTech, we deliver innovative, reliable, and scalable services
                                    tailored to meet your business needs. From ideation to deployment, our expert team
                                    ensures your technology investments create maximum value and long-term success. </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
                    style="transform: translateZ(0);">
                    <svg class="absolute bottom-0 overflow-hidden" xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                        <polygon class="text-blueGray-200 fill-current" points="2560 0 2560 100 0 100"></polygon>
                    </svg>
                </div> -->
            </div>

            <section class="pb-20 bg-blueGray-200 -mt-24">
                <div class="container mx-auto px-4">
                    <div class="flex flex-wrap">
                        <div  class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                            <div
                                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                                <div class="px-4 py-5 flex-auto">
                                    <div
                                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                                        <i class="fas fa-award"></i>
                                    </div>
                                    <h6 class="text-xl font-semibold"> Contract Design & Feasibility </h6>
                                    <p class="mt-2 mb-4 text-blueGray-500">
                                        We assess requirements, risks, and technical viability to ensure projects are well-defined and positioned for successful execution.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="w-full md:w-4/12 px-4 text-center" >
                            <div
                                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                                <div class="px-4 py-5 flex-auto">
                                    <div
                                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-400">
                                        <i class="fas fa-retweet"></i>
                                    </div>
                                    <h6 class="text-xl font-semibold"> Operation & Maintenance Support</h6>
                                    <p class="mt-2 mb-4 text-blueGray-500">
                                        We provide ongoing support to maintain system performance, reliability, and stability throughout the solution lifecycle.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="pt-6 w-full md:w-4/12 px-4 text-center" >
                            <div
                                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                                <div class="px-4 py-5 flex-auto">
                                    <div
                                        class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400">
                                        <i class="fas fa-fingerprint"></i>
                                    </div>
                                    <h6 class="text-xl font-semibold"> Program Monitoring &  Management </h6>
                                    <p class="mt-2 mb-4 text-blueGray-500">
                                        We oversee program progress, performance, and risks to ensure initiatives remain aligned with timelines, budgets, and business objectives.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="flex flex-wrap items-center mt-32" id="contract-design-feasibility">
                        <div class="w-full md:w-5/12 px-4 mr-auto ml-auto" >
                            <div
                                class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                                <i class="fas fa-laptop-code text-xl"></i>
                            </div>
                            <h3 class="text-3xl mb-2 font-semibold leading-normal">
                               Contract Design & Feasibility
                            </h3>
                            <p class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-600">
                              Before every project begins, we ensure the foundation is solid. Our <span class="text-blueGray-700 font-bold">Contract Design & Feasibility</span> process helps organizations align expectations, assess risks, and validate technical and financial viability. This ensures smoother execution and long-term success.
                            </p>
                            <ul class="list-none mt-6">
                                <span
                                    class="text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400 MenuDropdown-item">
                                    🔹 What We Do </span>
                                <li class="py-2">
                                    <div class="flex items-center">
                                        <i class="fas fa-check text-green-500 mr-2"></i>
                                        <span class="text-blueGray-600">
                                            <span class="font-semibold">
                                                Contract Structuring </span>– Designing transparent, fair, and flexible agreements that balance client requirements with deliverable outcomes.
                                        </span>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center">
                                        <i class="fas fa-check text-green-500 mr-2"></i>
                                        <span class="text-blueGray-600">
                                            <span class="font-semibold">
                                                Feasibility Studies</span> – Evaluating technical, operational, and financial feasibility of proposed solutions.
                                        </span>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center">
                                        <i class="fas fa-check text-green-500 mr-2"></i>
                                        <span class="text-blueGray-600">
                                            <span class="font-semibold">
                                                Risk Assessment</span> – Identifying potential risks and vulnerabilities in your project to ensure robust security and compliance.
                                        </span>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center">
                                        <i class="fas fa-check text-green-500 mr-2"></i>
                                        <span class="text-blueGray-600">
                                            <span class="font-semibold">
                                                Scalability & Compliance</span> – Ensuring projects align with industry standards, local regulations, and can scale with business growth.
                                        </span>
                                    </div>
                                </li>
                               
                                <li class="py-2">
                                    <div class="flex items-center">
                                        <i class="fas fa-check text-green-500 mr-2"></i>
                                        <span class="text-blueGray-600">
                                            <span class="font-semibold">
                                                Maintenance & Support </span> – Continuous monitoring, upgrades, and
                                            technical support to keep your apps running smoothly.
                                        </span>
                                    </div>
                                </li>
                                <!-- <li class="py-2">
                                    <div class="flex items-center">
                                        <i class="fas fa-check text-green-500 mr-2"></i>
                                        <span class="text-blueGray-600">
                                            <span class="font-semibold">
                                                Cloud Solutions </span> – Scalable and secure cloud infrastructure to
                                            support your applications.
                                        </span>
                                    </div>
                                </li> -->
                            </ul>
                        </div>

                        <div class="w-full md:w-4/12 px-4 mr-auto ml-auto">
                            <div
                                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-tb-lg bg-emerald-500" >
                                <img alt="..."
                                    src="@/assets/img/contract-design.jpg"
                                    class="w-full align-middle rounded-tb-lg" />
                           </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="relative py-20">
                <!-- <div class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
                    style="transform: translateZ(0);">
                    <svg class="absolute bottom-0 overflow-hidden" xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                        <polygon class="text-white fill-current" points="2560 0 2560 100 0 100"></polygon>
                    </svg>
                </div> -->

                <div class="container mx-auto px-4">
                    <div class="items-center flex flex-wrap" id="operation-maintenance">
                        <div class="w-full md:w-4/12 ml-auto mr-auto px-4">
                            <img alt="..." class="max-w-full rounded-lg shadow-lg"
                              src="@/assets/img/operation-maintenance.png"/>
                        </div>
                        <div class="w-full md:w-5/12 ml-auto mr-auto px-4">
                            <div class="md:pr-12">
                                <div
                                    class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                                    <i class="fas fa-rocket text-xl"></i>
                                </div>
                                <h3 class="text-3xl font-semibold">Operation & Maintenance Support (O&M)</h3>
                                <p class="mt-4 text-lg leading-relaxed text-blueGray-500">

                                  <span class="text-emerald-700 font-bold">Operation & Maintenance Support (O&M)</span> services are designed to ensure your systems run smoothly
                                    and efficiently. We provide tailored solutions that perfectly align with your business processes.
                                </p>
                                <ul class="list-none mt-6">
                                    <li class="py-2">
                                        <div class="flex items-center">
                                            <div>
                                                <span
                                                    class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-emerald-600 text-blueGray-500 mr-3">
                                                    <i class="far fa-paper-plane"></i>
                                                </span>
                                            </div>
                                            <div>
                                                <h4 class="text-blueGray-600">
                                                    Proactive Monitoring
                                                </h4>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="py-2">
                                        <div class="flex items-center">
                                            <div>
                                                <span
                                                    class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-emerald-600 text-blueGray-500 mr-3">
                                                    <i class="far fa-paper-plane"></i>
                                                </span>
                                            </div>
                                            <div>
                                                <h4 class="text-blueGray-600">
                                                    Preventive & Corrective Maintenance
                                                </h4>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="py-2">
                                        <div class="flex items-center">
                                            <div>
                                                <span
                                                    class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-emerald-600 text-blueGray-500 mr-3">
                                                    <i class="far fa-paper-plane"></i>
                                                </span>
                                            </div>
                                            <div>
                                                <h4 class="text-blueGray-600">
                                                  Performance Optimization</h4>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="py-2">
                                        <div class="flex items-center">
                                            <div>
                                                <span
                                                    class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-emerald-600 text-blueGray-500 mr-3">
                                                    <i class="far fa-paper-plane"></i>
                                                </span>
                                            </div>
                                            <div>
                                                <h4 class="text-blueGray-600">Security & Compliance

                                                </h4>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="py-2">
                                        <div class="flex items-center">
                                            <div>
                                                <span
                                                    class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-emerald-600 text-blueGray-500 mr-3">
                                                    <i class="far fa-paper-plane"></i>
                                                </span>
                                            </div>
                                            <div>
                                                <h4 class="text-blueGray-600">End-User Support</h4>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="py-2">
                                        <div class="flex items-center">
                                            <div>
                                                <span
                                                    class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-emerald-600 text-blueGray-500 mr-3">
                                                    <i class="far fa-paper-plane"></i>
                                                </span>
                                            </div>
                                            <div>
                                                <h4 class="text-blueGray-600">Ongoing Support & Maintenance</h4>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        

                    <div class="flex flex-wrap items-center mt-32" id="financial-modelling">
                        <div class="w-full md:w-5/12 px-4 mr-auto ml-auto">
                            <div
                                class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                                <i class="fas fa-laptop-code text-xl"></i></div>
                            <h3 class="text-3xl mb-2 font-semibold leading-normal"> Financial modelling
                            </h3>
                            <p class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-600">
                              Sound financial planning is the backbone of sustainable growth. Our <span class="text-blueGray-700 font-bold">Financial Modelling</span> services provide businesses with accurate forecasts, scenario analysis, and data-driven insights to support investment, project evaluation, and strategic decision-making.
                                
                            </p>
                            <ul class="list-none mt-6">
                                <span
                                    class="text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400 MenuDropdown-item">
                                    🔹 What We Offer </span>
                                <li class="py-2">
                                    <div class="flex items-center">
                                        <i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold"> Business Valuation Models </span>
                                            – Assessing the true value of businesses, startups, and assets with transparent, data-backed models.
                                        </span>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold">Project Feasibility & ROI Analysis</span> – Evaluating potential investments with scenario-based forecasting and risk-adjusted returns.</span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold"> Cash Flow & Budget Forecasting</span> – Building dynamic models that help track, optimize, and predict financial health.</span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold"> Scenario & Sensitivity Analysis</span> – Stress-testing assumptions to evaluate best-case, worst-case, and realistic outcomes. </span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold"> Custom Financial Dashboards</span> – Protect your data with enterprise-grade security and compliance standards. </span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold">Interactive tool</span> – Simplify financial data for quick decision-making.</span></div>
                                </li>
                                
                            </ul>
                        </div>
                        <div class="w-full md:w-4/12 px-4 mr-auto ml-auto">
                            <div
                                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-emerald-500">
                                <img alt="..."
                                    src="@/assets/img/financial-modelling.jpg"
                                    class="w-full align-middle rounded-t-lg">
                                <blockquote class="relative p-8 mb-4"><svg preserveAspectRatio="none"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                        class="absolute left-0 w-full block h-95-px -top-94-px">
                                        <polygon points="-30,95 583,95 583,65" class="text-emerald-500 fill-current">
                                        </polygon>
                                    </svg>
                                    <ul>
                                        <h4 class="text-xl font-bold text-white"> Benefits of Financial Modeling</h4>
                                        <li class="text-md mt-2 text-white"><i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>Informed Decision-Making</li>
                                        <li class="text-md mt-2 text-white"><i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>Investor Confidence</li>
                                        <li class="text-md mt-2 text-white"><i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>Efficiency & Accuracy</li>
                                        <li class="text-md mt-2 text-white"><i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>Growth Planning</li>
                                        
                                    </ul>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                    
                </div>


                
            </section>



 <section class="relative py-20">
                <!-- <div class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
                    style="transform: translateZ(0);">
                    <svg class="absolute bottom-0 overflow-hidden" xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                        <polygon class="text-white fill-current" points="2560 0 2560 100 0 100"></polygon>
                    </svg>
                </div> -->

                <div class="container mx-auto px-4">
                    <div class="items-center flex flex-wrap" id="smart-infrastructure-services">
                        <div class="w-full md:w-4/12 ml-auto mr-auto px-4">
                            <img alt="..." class="max-w-full rounded-lg shadow-lg"
                                src="@/assets/img/Smart-Infrastructure-Services.png" />
                        </div>
                        <div class="w-full md:w-5/12 ml-auto mr-auto px-4">
                            <div class="md:pr-12">
                                <div
                                    class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                                    <i class="fas fa-rocket text-xl"></i>
                                </div>
                               <h3 class="text-3xl mb-2 font-semibold leading-normal"> Smart Infrastructure Services
                            </h3>
                            <p class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-600"> 
At <span class="text-blueGray-700 font-bold">AmeiseTech</span>, we empower cities, industries, and enterprises with <span class="text-blueGray-700 font-bold">Smart Infrastructure Services</span> that combine <span class="text-blueGray-700 font-bold">IoT, AI, Cloud, and Automation</span> to build intelligent, connected, and sustainable systems.

                            </p>
                                 <ul class="list-none mt-6">
                                <span
                                    class="text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400 MenuDropdown-item">
                                    🔹 What We Offer </span>
                                <li class="py-2">
                                    <div class="flex items-center">
                                        <i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600">
                                            <span class="font-semibold">Smart Cities Solutions</span> – IoT-enabled systems for traffic, utilities, and public safety.
                                        </span>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center">
                                        <i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600">
                                            <span class="font-semibold">Surveillance</span> – AI based Video Analytics, CCTV installation and Integration.
                                        </span>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600">
                                            <span class="font-semibold">Energy Management</span> – AI-powered monitoring and optimization of energy usage.</span></div>
                                            
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600">
                                            <span class="font-semibold">IoT-Driven Infrastructure</span> – Connected devices and sensors for real-time insights.
                                            </span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold"> 
                                              Intelligent Buildings</span> – Automation for security, lighting, HVAC, and smart workplaces.</span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold">
                                              Sustainable Infrastructure</span> – Green energy integration and carbon footprint reduction.</span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold">Managed Services</span> –  Interactive tools for management and services to manage organization IT Infrastructure </span></div>
                                </li>
                                
                            </ul>
                            </div>
                        </div>
                    </div>


                    <div class="flex flex-wrap items-center mt-32" id="design-engineering-services">
                        <div class="w-full md:w-5/12 px-4 mr-auto ml-auto">
                            <div
                                class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                                <i class="fas fa-laptop-code text-xl"></i></div>
                            <h3 class="text-3xl mb-2 font-semibold leading-normal"> Design & Engineering Services
                            </h3>
                            <p class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-600"> 
                                At <span class="text-blueGray-700 font-bold">AmeiseTech</span>, we combine<span class="text-blueGray-700 font-bold"> innovation, precision, and technology</span> to deliver world-class <span class="text-blueGray-700 font-bold">  design and engineering solutions</span>. From concept to execution, our team ensures your projects are efficient, sustainable, and built for the future.
                            </p>
                            <ul class="list-none mt-6">
                                <span
                                    class="text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400 MenuDropdown-item">
                                    🔹 Our Expertise</span>
                                <li class="py-2">
                                    <div class="flex items-center">
                                        <i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold"> Conceptual & Detailed Design</span> – Transforming ideas into practical, scalable solutions.
                                        </span>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold">Product Engineering</span> – End-to-end design, prototyping, and development.</span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold"> Digital Transformation</span> – Modernize legacy systems and adopt next-gen technologies.</span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold"> Civil & Structural Engineering</span> – Reliable and sustainable infrastructure design.</span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold">Mechanical & Electrical Design</span> – Advanced systems tailored to project needs.</span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold">Digital Engineering (BIM, CAD, Simulation)</span> – Enhancing accuracy and efficiency with modern tools.</span></div>
                                </li>
                                <li class="py-2">
                                    <div class="flex items-center"><i class="fas fa-check text-green-500 mr-2"></i><span
                                            class="text-blueGray-600"><span class="font-semibold">Custom Software Solutions</span> – Tailored software to improve workflows and efficiency.</span></div>
                                </li>
                            </ul>
                        </div>
                        <div class="w-full md:w-4/12 px-4 mr-auto ml-auto">
                            <div
                                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-emerald-500">
                                <img alt="..."
                                    src="@/assets/img/Design-Engineering-Services.jpg"
                                    class="w-full align-middle rounded-t-lg">
                                <blockquote class="relative p-8 mb-4"><svg preserveAspectRatio="none"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                        class="absolute left-0 w-full block h-95-px -top-94-px">
                                        <polygon points="-30,95 583,95 583,65" class="text-emerald-500 fill-current">
                                        </polygon>
                                    </svg>
                                    <ul>
                                        <h4 class="text-xl font-bold text-white">What We Deliver </h4>
                                        <li class="text-md mt-2 text-white"> <i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>End-to-end product design from concept to deployment</li>
                                        <li class="text-md mt-2 text-white"><i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>Scalable, future-ready engineering solutions</li>
                                        <li class="text-md mt-2 text-white"><i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>Faster time-to-market with optimized workflows</li>
                                        <li class="text-md mt-2 text-white"><i
                                                class="fas fa-dot-circle text-green-500 mr-2"></i>Secure, compliant, and performance-driven systems</li>
                                        <li class="text-md mt-2 text-white"></li>
                                    </ul>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                    
                </div>


                
            </section>


            <!-- <section class="pt-20 pb-48">
                <div class="container mx-auto px-4">
                    <div class="flex flex-wrap justify-center text-center mb-24">
                        <div class="w-full lg:w-6/12 px-4">
                            <h2 class="text-4xl font-semibold">Scope of work</h2>
                            <p class="text-lg leading-relaxed m-4 text-blueGray-500">
                                Our Smart Infrastructure solutions encompass a wide range of applications designed to enhance urban living, improve operational efficiency, and promote sustainability. Key areas include:
                            </p>
                        </div>
                    </div>
                    <div class="flex flex-wrap">
                        <div class="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4" style="width: 20%;">
                            <div class="px-6">
                                <img alt="..." :src="team1" class="shadow-lg " style="width: 50%; margin-left: 40px;"/>
                                <div class="pt-6 text-center">
                                    <h5 class="text-xl font-bold">Smart Bus Stops</h5>
                                    <p class="mt-1 text-sm text-blueGray-400 font-semibold">
                                        At AmeiseTech, we are redefining urban mobility with Smart Bus Stops
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4" style="width: 20%;">
                            <div class="px-6">
                                <img alt="..." :src="team2" class="shadow-lg " style="width: 50%; margin-left: 40px;" />
                                <div class="pt-6 text-center">
                                    <h5 class="text-xl font-bold">Surveillance System</h5>
                                    <p class="mt-1 text-sm text-blueGray-400 font-semibold">
                                        Advanced surveillance solutions for enhanced security and situational awareness.
                                    </p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4" style="width: 20%;">
                            <div class="px-6">
                                <img alt="..." :src="team3" class="shadow-lg " style="width: 50%; margin-left: 40px;"/>
                                <div class="pt-6 text-center">
                                    <h5 class="text-xl font-bold">Multi-Services Digital Kiosk</h5>
                                    <p class="mt-1 text-sm text-blueGray-400 font-semibold">
                                        revolutionize how they work, innovate, and grow with Gen AI
                                    </p>
                                   
                                </div>
                            </div>
                        </div>
                        <div class="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4" style="width: 20%;">
                            <div class="px-6">
                                <img alt="..." :src="team4" class="shadow-lg " style="width: 50%; margin-left: 40px;" />
                                <div class="pt-6 text-center">
                                    <h5 class="text-xl font-bold">Environmental Sensor</h5>
                                    <p class="mt-1 text-sm text-blueGray-400 font-semibold">
                                        Real-time monitoring and analytics for air quality, noise levels, and weather conditions.
                                    </p>
                                   
                                </div>
                            </div>
                        </div>
                        <div class="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4" style="width: 20%;">
                            <div class="px-6">
                                <img alt="..." :src="team5" class="shadow-lg " style="width: 50%; margin-left: 40px;" />
                                <div class="pt-6 text-center">
                                    <h5 class="text-xl font-bold">Digital Outdoor Display</h5>
                                    <p class="mt-1 text-sm text-blueGray-400 font-semibold">
                                        Engaging, dynamic content delivery for advertising, information, and public messaging.
                                    </p>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

             -->
          
        </main>
        <footer-component />
    </div>
</template>
<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";

import team1 from "@/assets/img/bus-stop.png";
import team2 from "@/assets/img/cctv-camera.png";
import team3 from "@/assets/img/kiosk.png";
import team4 from "@/assets/img/metering.png";
import team5 from "@/assets/img/motion-sensor.png";
import backgroundImage from "@/assets/img/servicesbg.jpg";


export default {
    data() {
        return {
            team1,
            team2,
            team3,
            team4,
            team5,
            backgroundImage,
        };
    },
    components: {
        IndexNavbar,
        FooterComponent,
    },
};
</script>
<style scoped>
.px-4 {
    padding-left: 0rem !important;
    padding-right: 1rem;
}
</style>
